import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import ApiActions from 'go/actions/api';
import {API_RULES_GET_SUCCESS} from 'common/types';

export class StatutoryListener extends Component {
  componentDidMount() {
    if (
      this.props.grantId !== undefined &&
      this.props.fundingOpportunityId !== undefined
    ) {
      this.initializeRules();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      !_.isEqual(this.props.awardRecommendation, prevProps.awardRecommendation) &&
      !_.isEmpty(this.props.awardRecommendation) &&
      this.props.fundingOpportunityId !== undefined
    ) {
      this.initializeRules();
    }

    if (
      !_.isEqual(this.props.object, prevProps.object) &&
      !_.isEmpty(this.props.object) &&
      this.props.fundingOpportunityId !== undefined
    ) {
      this.initializeRules();
    }
  }

  initializeRules = _.debounce(
    () => {
      let {
        getRules,
        getRulesByGrant,
        token,
        duns,
        ueiEft,
        grantId,
        fundingOpportunityId,
        saveEntitySessionData,
        toggles,
        ruleSetByGrant,
        ruleSetByDuns,
      } = this.props;
      const dunsToUEIToggle = _.includes(toggles, 'dunsToUEI');
      const configByGrant = [
        {
          configType: 'fo',
          configId: `${fundingOpportunityId}`,
          ruleSet: ruleSetByGrant ? ruleSetByGrant : 'statutoryRecommendation',
        },
      ];
      const configByDuns = [
        {
          configType: 'fo',
          configId: `${fundingOpportunityId}`,
          ruleSet: ruleSetByDuns ? ruleSetByDuns : 'statutoryRecommendationByDuns',
        },
      ];
      let statByGrant = [];
      let statByDuns = [];
      const grantStatCall = getRules(token, grantId, configByGrant);

      let dunsStatCall = null;

      //Remove the toggle once the toggles are in PROD
      const isDuns = !_.isEmpty(_.trim(duns)) && !_.isEqual(_.trim(duns), 'null');
      const isUeiEft = !_.isEmpty(_.trim(ueiEft)) && !_.isEqual(_.trim(ueiEft), 'null');
      const hasDunsOrUei = dunsToUEIToggle ? isUeiEft : isDuns;

      if (hasDunsOrUei) {
        dunsStatCall = getRulesByGrant(token, grantId, hasDunsOrUei, configByDuns);
      } else {
        dunsStatCall = Promise.resolve([]);
      }
      Promise.all([grantStatCall, dunsStatCall])
        .then((values) => {
          const grantRes = values[0];
          const dunsRes = values[1];
          if (grantRes.type === API_RULES_GET_SUCCESS) {
            statByGrant = grantRes.payload;
          }
          if (dunsRes.type === API_RULES_GET_SUCCESS) {
            statByDuns = dunsRes.payload;
          }

          let statutoryPayload = _.filter(
            _.flatten(_.concat(statByGrant, statByDuns)),
            _.size
          );

          saveEntitySessionData('context.statutory', {
            loading: false,
            payload: statutoryPayload,
          });
        })
        .catch((error) => console.log(error));
    },
    3500,
    {trailing: true}
  );

  render() {
    return <React.Fragment />;
  }
}

export const mapStateToProps = (state) => ({
  token: state.auth.token,
  toggles: state.toggles.toggles,
});

export const mapDispatchToProps = (dispatch) => ({
  getRules: (token, grantId, config) => {
    const action = ApiActions.rules.getRules(token, grantId, config);
    const response = dispatch(action);
    return response;
  },
  //Remove the toggle once the toggles are in PROD
  getRulesByGrant: (token, grantId, hasDunsOrUei, config) => {
    const action = ApiActions.rules.getRulesByGrant(token, grantId, hasDunsOrUei, config);
    const response = dispatch(action);
    return response;
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(connectDynamic(StatutoryListener));
